module.exports = __webpack_public_path__ + "static/media/bl.2deb442f.svg";